import { restDataProviderClient } from "@providers/data-provider/rest-data-provider.client";
import { SearchCategory } from "./types";

export const dataProvider = restDataProviderClient;
export const limit = 2;

export const searchCategories: Record<SearchCategory, string> = {
  "product": "Produk",
  "faq": "FAQ",
  "article": "Artikel",
};